import React, {useCallback, useEffect, useRef, useState} from 'react';
import throttle from 'lodash/throttle';

import {ReactTableDefaults} from 'react-table';

export const StickyColumnType = {
  FIRST: 'FIRST',
  LAST: 'LAST',
  BOTH: 'BOTH'
}

const useAddStuckClassName = (isSticky, type, ref) => {
  const toggleStuck = (type) => {
    const className = type === StickyColumnType.FIRST
      ? '.sticky-column_left'
      : type === StickyColumnType.LAST
        ? '.sticky-column_right'
        : '';

    return (isStuck) => {
      const method = isStuck ? 'add' : 'remove';

      ref.current.querySelectorAll(className).forEach($el => {
        $el.classList[method]('stuck');
      })
    }
  }

  useEffect(() => {
    const toggleStuckType = toggleStuck(type);

    if (isSticky) {
      toggleStuckType(true);
    } else {
      toggleStuckType(false);
    }
  }, [isSticky]);
};

const TableComponent = ({onScroll, stickyColumn = StickyColumnType.BOTH, isTableScroll, watch, ...props}) => {
  const firstColumnOffset = 0;
  const lastColumnSizeOffset = 0;

  const isColumnType = (type) => stickyColumn === type || stickyColumn === StickyColumnType.BOTH;

  const ref = useRef();
  const [isColumnsSticky, setIsColumnsSticky] = useState({
    firstColumn: false,
    lastColumn: false
  });

  const scrollListener = useCallback(({target}) => {
    let firstColumn = false;
    let lastColumn = false;

    if (target.scrollLeft > firstColumnOffset && isColumnType(StickyColumnType.FIRST)) {
      firstColumn = true;
    }

    if (target.scrollLeft + target.offsetWidth < target.scrollWidth - lastColumnSizeOffset && isColumnType(StickyColumnType.LAST)) {
      lastColumn = true;
    }

    setIsColumnsSticky((isColumnsSticky) => {
      if (isColumnsSticky.firstColumn !== firstColumn || isColumnsSticky.lastColumn !== lastColumn) {
        return {firstColumn, lastColumn};
      }

      return isColumnsSticky;
    })
  }, [firstColumnOffset, lastColumnSizeOffset]);

  const handleScroll = throttle(scrollListener, 200);

  useEffect(() => {
    if (ref.current && handleScroll) {
      ref.current.firstChild.addEventListener('scroll', handleScroll);

      return () => {
        ref.current.firstChild.removeEventListener('scroll', handleScroll);
      }
    }
  }, []);

  useEffect(() => {
    if (isTableScroll) {
      setIsColumnsSticky((isColumnsSticky) => ({
        ...isColumnsSticky,
        lastColumn: isColumnType(StickyColumnType.LAST)
      }))
    }
  }, [isTableScroll]);

  useAddStuckClassName(isColumnsSticky.firstColumn, StickyColumnType.FIRST, ref);
  useAddStuckClassName(isColumnsSticky.lastColumn, StickyColumnType.LAST, ref);

  return (
    <div ref={ref} className="table__scroll">
      <ReactTableDefaults.TableComponent {...props}/>
    </div>
  )
};

export default TableComponent;
